import React, { useState, useEffect } from "react";
import queryString from "query-string";

import lbl from "../../../data/Labels.json";
import db from "../../../services/query";

import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";

import SummaryTable from "../../finance/_dashboard/_dailyReport/SummaryTable";
import BalanceDataTables from "./DataTables";
import { tabHasRecords } from "../daily-report/printSectionUtils";

const AccountStatement = ({ match, location }) => {
  const { account } = match.params;
  const params = queryString.parse(location.search);

  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];
  let bodyTitle = { mainTitle: "بیلانس" };

  const [tableData, setTableData] = useState([]);
  const [data, setData] = useState([]);
  const [expenseTabs, setExpenseTabs] = useState([]);
  const [revenuesTabs, setRevenuesTabs] = useState([]);
  const [accountName, setAccountName] = useState(params.accountName || "");

  useEffect(() => {
    requestData();

    return () => setData([]);
  }, []);

  const requestData = async () => {
    try {
      await db
        .getAll(`dashboard/finance/account-statement/${account}`)
        .then(({ data }) => {
          setData(data.summary);
          setTableData(data.data[0]);
          const resolvedName =
            params.accountName ||
            data?.summary?.account_name ||
            data?.summary?.name ||
            data?.account_name ||
            "";
          setAccountName(resolvedName);
          requestTabs(data.data[0]);
        });

      if (!params.accountName) {
        await db.getAll(`accounts/${account}`).then(({ data }) => {
          const accountInfo = data?.data?.[0] || data?.[0] || data;
          if (accountInfo?.name) {
            setAccountName(accountInfo.name);
          }
        });
      }
    } catch ({ response }) {
      setData(response);
    }
  };

  const requestTabs = async (statementData) => {
    const [revenueTypes, expenseTypes] = await Promise.all([
      db.getAll("revenues/types"),
      db.getAll("expenses/types"),
    ]);

    const revenueList = revenueTypes?.data?.data ?? [];
    const expenseList = expenseTypes?.data?.data ?? [];

    setRevenuesTabs(
      revenueList.filter((tab) =>
        tabHasRecords(tab.id, "revenue_type_id", statementData)
      )
    );
    setExpenseTabs(
      expenseList.filter((tab) =>
        tabHasRecords(tab.id, "expense_type_id", statementData)
      )
    );
  };

  const title = accountName
    ? `گزارش حساب ${accountName}`
    : `گزارش حساب ${account}`;

  const hasSectionData =
    revenuesTabs.length > 0 || expenseTabs.length > 0;

  return (
    <main className="main-print-wrapper account-statement-print">
      <PrintHeader title={title} printHeadTexts={printHeadTexts} />
      <PrintBodyTitle title={bodyTitle} noPageBreak={true} />

      <div className="print-table-area">
        <div className="summary-table">
          <SummaryTable data={data} />
        </div>
      </div>
      {!hasSectionData ? (
        <p className="daily-report-empty-note">برای این حساب داده‌ای ثبت نشده است.</p>
      ) : null}
      {revenuesTabs.map(({ id, name, name_en }) => (
        <div key={`revenue-${id}`} className="account-statement-section">
          <PrintBodyTitle
            title={{ mainTitle: lbl.Revenues, subTitle: name }}
            noPageBreak={true}
          />
          <BalanceDataTables
            typeID={id}
            name={name_en}
            data={tableData?.revenues}
            typeName={"revenue_type_id"}
          />
        </div>
      ))}
      {expenseTabs.map(({ id, name, name_en }) => (
        <div key={`expense-${id}`} className="account-statement-section">
          <PrintBodyTitle
            title={{ mainTitle: lbl.Expenses, subTitle: name }}
            color={"#b75555"}
            noPageBreak={true}
          />
          <BalanceDataTables
            typeID={id}
            name={name_en}
            data={tableData?.expenses}
            typeName={"expense_type_id"}
          />
        </div>
      ))}
    </main>
  );
};

export default AccountStatement;
